import { Formik } from 'formik';
import React, { useMemo } from 'react';
import { Form } from 'react-bootstrap';

import { useEntitiesCreate, useProfileUpdate } from '../../../../hooks';
import { autocompleteEntities } from '../../../../utils/backend-api/entities';
import { AutoSave, Divider } from '../../../BaseUI';
import { MultiValueAutocompleteField } from '../../../FormFields';
import SkillsSchema from './SkillsSchema';

const Skills = ({ userId, skills, isDisabled }) => {
  const initialState = useMemo(
    () => ({
      skills: skills || [],
    }),
    [skills]
  );
  const { mutateAsync: createEntityAsync } = useEntitiesCreate();
  const { saveProfile, showSave, saveStatus } = useProfileUpdate(userId);

  const handleSubmit = ({ skills }) => {
    const sanitizedParams = { skills: skills.map((i) => i.value) };
    saveProfile(sanitizedParams);
  };

  return (
    <Formik initialValues={initialState} onSubmit={handleSubmit} validationSchema={SkillsSchema}>
      {(formik) => (
        <Form noValidate onSubmit={formik.handleSubmit}>
          <AutoSave debounceMs={500} />
          <div className="Skills section-container">
            <div className="section-header tw-mt-2">Professional Skills</div>
            <div className="section-detail">
              <div className="section-detail-container">
                {showSave && (
                  <div className={`save-label ${saveStatus === 'Saved' ? 'success' : 'failure'}`}>
                    {saveStatus}
                  </div>
                )}
              </div>
              <div className="section-form-container">
                <MultiValueAutocompleteField
                  placeholder="Type Skills"
                  label="My Skills"
                  name="skills"
                  isDisabled={isDisabled}
                  fetchMethod={(value) =>
                    autocompleteEntities({
                      fragment: value,
                      entity_type: 'skill',
                    })
                  }
                  createMethod={(value) =>
                    createEntityAsync({
                      name: value,
                      entity_type: 'skill',
                      word_type: 'common',
                    })
                  }
                />
              </div>
            </div>
            <Divider />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default Skills;
